<template>
  <a-modal
      title="修改专家备注"
      :visible="remarkVisible"
      :maskClosable="false"
      :width="960"
      destroyOnClose
      @ok="onSave"
      @cancel="$emit('cancel')"
      :confirmLoading="loading">
    <a-form-model :model="expertInfo" ref="form" :rules="rules" class="exi_form item_100"
                  :label-col="{ flex: '0 0 150px' }" :wrapper-col="{ span: 24 }">
      <a-form-model-item label="备注">
        <a-textarea
            placeholder="请填写备注"
            :atow-size="{minSize:5,maxSize:8}"
            v-model="expertInfo.remark"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { UpdateRemarkExpertById } from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'

const rules = {
  remark: [{ required: true, message: '备注不能为空！', trigger: 'change' }],
}

export default {
  name: 'EditExpertRemarkModal',
  computed: {},
  components: {},
  props: {
    remarkVisible: {
      type: Boolean,
      default: false
    },
    expertInfo: {
      type: Object,
      default: () => {
        return {
          remark: undefined
        }
      }
    }
  },
  data () {
    return {
      rules: rules,
      loading: false,
    }
  },
  methods: {
    //回传输入的值
    onSave () {
      let that = this
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          that.loading = true
          const data = { id: that.expertInfo.id, remark: that.expertInfo.remark }
          let res = await UpdateRemarkExpertById(data)
          if (200 !== res.code) {
            this.$message.error('修改失败')
            return
          }
          this.$message.success('修改成功')
          this.$emit('success')
        } catch (e) {
          this.$message.error(e.message)
        } finally {
          that.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
